import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import './App.css';
import Moment from 'moment';
import InputMask from 'react-input-mask'; 
import AppSettings from './App.json'

class GroupDetail extends Component {

    constructor(props) {
        super(props)
        this.state = {
          groupID: 0,
          resultMessage: "",
          errorMessage: "",
          firstName: "",
          lastName: "",
          emailAddress: "",
          mobilePhone: "",
          comments: "",
        };
        this.FirstName = React.createRef()
        this.LastName = React.createRef()
        this.EmailAddress = React.createRef()
        this.MobilePhone = React.createRef()
        this.Comment = React.createRef()
        this.resultMessage = React.createRef();
    }

    componentDidMount() {
        console.log('GroupDetail::componentDidMount')
        const queryParams = new URLSearchParams(window.location.search)
        const groupID = queryParams.get("g")
        this.setState({
          groupID: groupID,
        }, this.GetGroupDetail(groupID))  
    }

    GetGroupDetail = (groupID) => {
        console.log('GroupDetail::GetGroupDetail');
        //let _url = "https://localhost:44374/SmallGroupWidget/API/GetGroupDetail?g=" + groupID;
        //let _url = "https://charliebrown.pointsnorthsys.com/SmallGroupWidgetWebAPI/API/GetGroupDetail?g=" + groupID;
        let _url = AppSettings.SERVER_URL + '/API/GetGroupDetail?g=' + groupID
        fetch(_url, {
            method: "GET",
          })
          .then(async response => {
            const data = await response.json(); 
            const record = data.Group;
            let _group = {groupID: record.Group_ID, groupName: record.Group_Name, description: record.Description, meetingDay: record.Meeting_Day, meetingTime: record.Meeting_Time, meetsOnline: record.Meets_Online, nextMeetingDate: record.Next_Scheduled_Meeting, address1: record.Address_Line_1, address2: record.Address_Line_2, city: record.City, state: record.State_Region, zip: record.Postal_Code, lifeStage: record.Life_Stage, groupLeaders: record.Group_Leaders };
            this.setState({
              group: _group,
            });
          })
          .catch(error => {
            console.error('GroupDetail::GetGroupDetail: There was an error!', error);
        });
    };   
    
    ReturnLocation = (city, state, zip) => {
      let x=''
      if (city) {
        x += city + ', ' + state + ' ' + zip
      }
      return (<div><span className='groupLabel'>Location:&nbsp;</span><span className='groupData'>{x}</span></div>);
    }
    
    ReturnMeetingDayTime = (meetingDay, meetingTime) => {
      let x=''
      if (meetingDay) {
        var dt = new Date('01/01/1970 ' + meetingTime);
        x += meetingDay + 's @ ' + Moment(dt).format('h:mm A')
      }
      return (<div><span className='groupLabel'>Meeting Day:&nbsp;</span><span className='groupData'>{x}</span></div>);
    }
    
    ReturnLifeStage = (lifeStage) => {
      let x=''
      if (lifeStage) {
        x += lifeStage
      }
      return (<div><span className='groupLabel'>Life Stage:&nbsp;</span><span className='groupData'>{x}</span></div>);
    }
    
    ReturnNextMeetingTime = (nextMeetingDate) => {
      let x=''
      if (nextMeetingDate) {
        var dt = new Date(nextMeetingDate);
        x += Moment(dt).format('MMMM D, yyyy')
      }
      return (<div><span className='groupLabel'>Next Meeting:&nbsp;</span><span className='groupData'>{x}</span></div>);
    }

    ReturnNextMeetingFormat = (meetsOnline) => {
      let x=(meetsOnline) ? "Meets Online" : "Meets In-Person"
      return (<div><span className='groupLabel'>Format:&nbsp;</span><span className='groupData'>{x}</span></div>);
    }

    ReturnDescription = (description) => {
      return (<div><span className='groupData'>{description}</span></div>);
    }

    ReturnLeaders = (leaders) => {
      let x=''      
      x = leaders.map(leader => {
        if (leader.Photo_GUID) {
          return (
            <span className='groupLeaderSpan' key={leader.Group_Participant_ID}>
              <span><img className='groupLeaderPhoto' src={AppSettings.Leader_URL + '/files/' + leader.Photo_GUID} alt='Small Grout Leader'></img></span>
              <span className='groupLeaderName groupData'>{leader.Display_Name}</span>
            </span>
          )
        }
        else {
          return (
            <span className='groupLeaderSpan' key={leader.Group_Participant_ID}>
              <span className='groupLeaderName groupData'>{leader.Display_Name}</span>
            </span>
          )
        }
      })
      return (<div className=''><div className='groupLabel'>Leaders:&nbsp;</div><div className='groupLeaderSpanDiv'>{x}</div></div>);
    }

    JoinGroupClicked = () => {      
      console.log('GroupDetail::JoinGroupClicked')
      if (this.ValidateFields()) {
        this.SaveGroupSignUp();
      }
    }

    ValidateFields = () => {
      console.log('GroupDetail::ValidateFields')
      let valid = true;
      if (this.state.firstName === "") 
      { 
          this.FirstName.current.className += ' invalidInput'
          valid = false
      } 
      else 
      {
        this.FirstName.current.className = 'formFieldLabel'
      }
      if (this.state.lastName === "") 
      { 
          this.LastName.current.className += ' invalidInput'
          valid = false
      } 
      else 
      {
        this.LastName.current.className = 'formFieldLabel'
      }
      if (this.state.emailAddress === "") 
      { 
          this.EmailAddress.current.className += ' invalidInput'
          valid = false
      } 
      else 
      {
        this.EmailAddress.current.className = 'formFieldLabel'
      }
      if (this.state.mobilePhone === "") 
      { 
        this.MobilePhone.current.className = ' invalidInput'
          valid = false
      } 
      else 
      {
        this.MobilePhone.current.className = 'formFieldLabel'
      }
      if (valid) {
        this.setState({resultMessage: "", errorMessage: ''})
      } else {
        this.setState({resultMessage: "", errorMessage: 'Please completed all required fields.'})
      }
      return valid
    }

    OnChangeFirstName = (e) => {
      console.log('GroupDetail::OnChangeFirstName')
      this.setState({
        firstName: e.target.value,
      })
    }

    OnChangeLastName = (e) => {
      console.log('GroupDetail::OnChangeLastName')
      this.setState({
        lastName: e.target.value,
      })
    }

    OnChangeEmailAddress = (e) => {
      console.log('GroupDetail::OnChangeEmailAddress')
      this.setState({
        emailAddress: e.target.value,
      })
    }

    OnChangeMobilePhone = (e) => {
      console.log('GroupDetail::OnChangeMobilePhone')
      this.setState({
        mobilePhone: e.target.value,
      })
    }

    OnChangeComments = (e) => {
      console.log('GroupDetail::OnChangeComments')
      this.setState({
        comments: e.target.value,
      })
    }

    SaveGroupSignUp = () => {
      console.log('GroupDetail::SaveGroupSignUp')
      let _url = AppSettings.SERVER_URL + '/API/SaveGroupSignUp'
      let _data = { groupID: this.state.groupID, firstName: this.state.firstName, lastName: this.state.lastName, emailAddress: this.state.emailAddress, mobilePhone: this.state.mobilePhone, comment: this.state.comments }
      fetch(_url, { 
          method: "POST",
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(_data)
        })
        .then(async response => { 
          const data = await response.json()
          if (data.status === "Success") {
              this.setState({resultMessage: data.result})                
          } else {
              this.setState({errorMessage: data.result})
          }
        })
        .catch(error => {
          console.error('GroupDetail::SaveGroupSignUp: There was an error!', error)
        });

    }

    closeClicked = () => {
        this.props.history.push('/SmallGroupWidget/groups')
    }

    render() {
      if (this.state.group) {
            const group = this.state.group
            return (
              <div>
                <div className='backLinkDiv'>
                  <button className='backLink' onClick={()=>{this.closeClicked()}} >&#129056;&nbsp;Back to Groups Listing</button>  
                </div>
                <div className="groupDetailDiv">
                    <div className="groupNameDiv">{group.groupName}</div>                  
                    <div className="groupLocationDiv">{this.ReturnLocation(group.city, group.state, group.zip)}</div>                  
                    <div className="groupMeetingTimeDiv">{this.ReturnMeetingDayTime(group.meetingDay,group.meetingTime)}</div>                  
                    <div className="groupMeetingTimeDiv">{this.ReturnNextMeetingFormat(group.meetsOnline)}</div>                  
                    <div className="groupMeetingTimeDiv">{this.ReturnNextMeetingTime(group.nextMeetingDate)}</div>     
                    <div className="groupMeetingTimeDiv">{this.ReturnLifeStage(group.lifeStage)}</div>     
                    <div className="groupMeetingTimeDiv">{this.ReturnLeaders(group.groupLeaders)}</div>
                    <div className="groupDescriptionDiv">{this.ReturnDescription(group.description)}</div>     
                    <div className='signUpForm'>
                      <div className='signUpFormInstructions'>
                        <b>Instructions:</b>&nbsp;If you are interested in joining this group please fill out the information below and submit.  Someone from the group will contact you shortly.
                      </div>
                      <div className='detailFormFieldDiv'>
                        <span className='formFieldLabel' ref={this.FirstName}>Firstname</span>
                        <input data-superscript="8" className='form-control' value={this.state.firstName} onChange={this.OnChangeFirstName} ></input>
                      </div>
                      <div className='detailFormFieldDiv'>
                        <span className='formFieldLabel' ref={this.LastName}>Lastname</span>
                        <input className='form-control' value={this.state.lastName} onChange={this.OnChangeLastName}></input>
                      </div>
                      <div className='detailFormFieldDiv'>
                        <span className='formFieldLabel' ref={this.EmailAddress}>Email</span>
                        <input className='form-control' value={this.state.emailAddress} onChange={this.OnChangeEmailAddress}></input>
                      </div>
                      <div className='detailFormFieldDiv'>
                        <span className='formFieldLabel' ref={this.MobilePhone}>Mobile</span>
                        <InputMask className='form-control' value={this.state.mobilePhone} mask="999-999-9999"  maskChar=""  onChange={this.OnChangeMobilePhone} />
                      </div>
                      <div className='detailFormFieldDiv'>
                        <span className='formFieldLabel' ref={this.Comment}>Comment</span>
                        <textarea className='form-control' value={this.state.comments} onChange={this.OnChangeComments} ></textarea>
                      </div>
                      <div className="joinButtonDiv">
                        <button className='joinButton' onClick={()=>this.JoinGroupClicked()}>Join Group</button>
                        <div className='resultMessageDiv'>
                          <span className='resultMessage'>{this.state.resultMessage}</span>
                          <span className='errorMessage'>{this.state.errorMessage}</span>
                        </div>
                      </div>     
                    </div>
                </div>    
              </div>                    
            )
      }
      else {
        return (
          <div className="row flex-grow-1">		
            Loading Group...
          </div>
        )
      }
    }
}

export default withRouter(GroupDetail)